import api from "@/api/v1-jwt/config/api";

export const fetchProfile = async (userId) => {
  if (!userId) {
    throw new Error("[FETCH_PROFILE] User ID missing.");
  }

  const { data } = await api.get(`/platform/profile/${userId}`);
  return data;
};
